<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="权限名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="权限名称搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item  label="所属分组" prop="team_id">
                <el-select
                    v-model="form.team_id"
                    filterable
                    clearable
                    placeholder="选择分组"
                    class="team_idc"
                >
                    <el-option
                        v-for="item in AllRouterTeam"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="菜单显示" prop="is_menu">
                <el-select
                    v-model="form.is_menu"
                    placeholder="请选择"
                    class="menuc"
                    clearable
                >
                    <el-option label="是" :value=1></el-option>
                    <el-option label="否" :value=0></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(AddAuth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加权限</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'RouteSearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                name: '',
                team_id: '',
                is_menu:'',
                page: 1,
            }
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        AllRouterTeam: {
            type: Array,
            default() {
                return []
            },
        },
        AddAuth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style lang='less' scoped>
.box-card .el-form-item {
    margin-bottom: 3px;
}
.temp_add {
    float: right;
    margin-bottom: 10px;
}

.menuc {
    width: 100px;
}
</style>